module.exports = __webpack_public_path__ + "static/media/AmEx.a824b078.svg";